import { api, download } from "../helpers";

export const getList = (payload, token) =>
	api("/community-leaders", "GET", undefined, payload, token);

export const getStats = (params, token) =>
	api("/points/community-leader-members", "GET", undefined, params, token);

export const getRegionsStats = (params, token) =>
	api("/points/community-leader-area", "GET", undefined, params, token);

export const getDetail = ({ id }, token) =>
	api("/community-leaders/" + id, "GET", undefined, undefined, token);

export const updateStatus = ({ id, ...payload }, token) =>
	api("/community-leaders/" + id + "/status", "PUT", payload, {}, token);

export const exportCommunityLeaders = (params, token) =>
	download("/community-leaders/export", params, token);

export const exportCommunityLeadersArea = (params, token) =>
	download("/points/community-leader-area-export", params, token);

export const exportCommunityLeadersMembersAndEvents = (params, token) =>
	download("/points/community-leader-members-export", params, token);
